import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import boldSvg from '@/images/toolbar/Bold.svg';
import italicSvg from '@/images/toolbar/Italic.svg';
import overlineSvg from '@/images/toolbar/Overline.svg';
import underlineSvg from '@/images/toolbar/Underline.svg';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { ElementType } from 'polotno/model/group-model';
import { ControlButton } from '../../common/ControlButton';

const Container = styled.div`
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
`;

export const FontStyleControl = observer(() => {
    const { store } = useAdvancedEditorContext();
    const elements = store.selectedElements;
    const element = elements[0] as ElementType & { fontWeight: string; fontStyle: string; textDecoration: string };

    const toggleStyles = (style: string) => {
        elements.forEach(e => {
            const element = e as ElementType & { fontWeight: string; fontStyle: string; textDecoration: string };
            const dec: string = element.textDecoration;

            if (style === 'bold') {
                element.fontWeight === 'bold' ? e.set({ fontWeight: 'normal' }) : e.set({ fontWeight: 'bold' });
            } else if (style === 'italic') {
                element.fontStyle === 'italic' ? e.set({ fontStyle: 'normal' }) : e.set({ fontStyle: 'italic' });
            } else if (style === 'underline') {
                if (dec.includes('underline')) {
                    e.set({ textDecoration: dec.replace('underline', '').trim() });
                } else {
                    e.set({ textDecoration: ('underline ' + dec).trim() });
                }
            } else if (style === 'overline') {
                const textDecoration = (dec.includes('line-through') ? dec.replace('line-through', '') : 'line-through ' + dec).trim();
                e.set({ textDecoration });
            }
        });
    };

    return (
        <Container>
            <ControlButton onClick={() => toggleStyles('overline')} selected={element.textDecoration.includes('line-through')}>
                <MaskedIcon src={overlineSvg} size="14px" />
            </ControlButton>
            <ControlButton onClick={() => toggleStyles('underline')} selected={element.textDecoration.includes('underline')}>
                <MaskedIcon src={underlineSvg} size="14px" />
            </ControlButton>
            <ControlButton onClick={() => toggleStyles('bold')} selected={element.fontWeight === 'bold'}>
                <MaskedIcon style={{ transform: 'translate(3px)' }} src={boldSvg} size="14px" />
            </ControlButton>
            <ControlButton onClick={() => toggleStyles('italic')} selected={element.fontStyle === 'italic'}>
                <MaskedIcon src={italicSvg} size="14px" />
            </ControlButton>
        </Container>
    );
});
